/**
 * Coming Soon Component
 * Shown when sports is disabled
 */

import React from 'react';
import styles from './ComingSoon.module.css';

const ComingSoon = () => {
  return (
    <div className={styles.comingSoon}>
      <div className={styles.content}>
        <h1>Sports Betting Coming Soon</h1>
        <p>We're working hard to bring you an amazing sports betting experience.</p>
        <p>Stay tuned for updates!</p>
      </div>
    </div>
  );
};

export default ComingSoon;
